import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { Button, Card, Text } from '@BICE_Vida/components';
import { Container } from '@BICE_Vida/scp-components';

import Image from 'next/image';
import { CAT } from '@/utils/assets';
import componentsId from '@/utils/componentsId';
import routes from '@/utils/routes';
import { benefitsPageTexts } from '@/utils/generalTexts';

import styles from './BenefitsBanner.module.scss';
import { breakPointXl } from '@/utils/constants';

const BenefitsBanner = () => {
  const router = useRouter();
  const [showMobile, setShowMobile] = useState(false);

  const btnEstimateClick = () => {
    router.push(routes.wizardPlan);
  };

  useEffect(() => {
    const onResizeBenefits = () => setShowMobile(window.innerWidth < breakPointXl);

    window.addEventListener('resize', onResizeBenefits);
    onResizeBenefits();

    return () => {
      window.removeEventListener('resize', onResizeBenefits);
    };
  }, []);

  return (
    <section id={componentsId.benefits.banner.section} className={styles.banner_section}>
      <Container className={styles.banner_container}>
        <Card className={styles.card}>
          <div className={styles.banner_card_container}>
            <div className={styles.banner_card_content}>
              <div className={styles.banner_image_container_mobile}>
                <Image src={CAT.CAT_WELCOME_BENETITS} alt="" width={128} height={128} />
              </div>

              <div className={styles.banner_description_container}>
                <Text className={styles.banner_title} fontTypo="title-xlarge" tag="h3">
                  {benefitsPageTexts.bannerTitle(showMobile)}
                </Text>
              </div>
              <div className={styles.banner_description_container}>
                <Text className={styles.banner_description} fontTypo="body-medium" tag="p">
                  {benefitsPageTexts.bannerDescription}
                </Text>
              </div>
              <div className={styles.btn_container}>
                <Button
                  text={benefitsPageTexts.bannerBtn}
                  size="large"
                  onClick={btnEstimateClick}
                  variant="primary"
                />
              </div>
              <div className={styles.banner_image_container}>
                <Image src={CAT.CAT_POINTING_BENEFITS} alt="" width={370} height={365} />
              </div>
            </div>
          </div>
        </Card>
      </Container>
    </section>
  );
};

export default BenefitsBanner;
